export default __webpack_public_path__ + "57ad5aedb1a08bd77ec25baa1eb14353.png";